import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: `'Open Sauce One', sans-serif`,
    fontSize: '13px',
    lineHeight: '20px',
    fontWeight: 400,
  },
  balance: {
    color: '#FAFAFA',
    textTransform: 'uppercase',
  },
  fiatValue: {
    color: '#949494',
  },
}));

type Props = {
  asset: string;
  balance: string;
  fiatBalance?: string;
  className?: string;
};

export const AssetBalance = ({ asset, balance, fiatBalance, className }: Props) => {
  const classes = useStyles();

  return (
    <div className={classNames(classes.wrapper, className)}>
      <p className={classes.balance}>
        {balance} {asset}
      </p>
      {Boolean(fiatBalance) && <p className={classes.fiatValue}>{fiatBalance}</p>}
    </div>
  );
};
